// Traduções dos tipos de itens para português
export const ITEM_TYPES = {
  WEAPON: 'Arma',
  ARMOR: 'Armadura/Roupão',
  BOOTS: 'Botas',
  GLOVES: 'Luvas',
  BRACELET: 'Bracelete',
  ACCESSORY: 'Acessório',
  ROBE: 'Roupão',
  SHIELD: 'Escudo',
};

// Função para obter a tradução do tipo de item
export const getItemTypeTranslation = (type) => {
  return ITEM_TYPES[type] || type;
};

// Ícones dos tipos de item
export const getTypeIcon = (type) => {
  const typeIcons = {
    WEAPON: '⚔️',
    ARMOR: '🛡️',
    BOOTS: '👢',
    GLOVES: '🧤',
    BRACELET: '📿',
    ACCESSORY: '💎',
    ROBE: '👘',
    SHIELD: '🛡️'
  };
  return typeIcons[type] || '📦';
};
